<template>
    <div class="content">
        <table class="table">
            <thead>
                <tr>
                    <th>
                        Naam
                    </th>
                    <th>
                        Kortingspercentage
                    </th>
                    <th>
                        Startdatum
                    </th>
                    <th>
                        Einddatum (optioneel)
                    </th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(discount, index) in discounts">
                    <td class="field">
                        <div class="field-control" :class="{'has-error': hasError(index, 'name')}">
                            <input type="text" v-model="discount.name">
                        </div>
                    </td>
                    <td class="field">
                        <div class="field-control" :class="{'has-error': hasError(index, 'discountPercentage')}">
                            <input type="number"
                                   min="0"
                                   max="100"
                                   v-model="discount.discountPercentage">
                        </div>
                    </td>
                    <td class="field">
                        <div class="field-control" :class="{'has-error': hasError(index, 'startDate')}">
                            <date-picker :format="dateFormat" v-model="discount.startDate" name="startDate" />
                        </div>
                    </td>
                    <td class="field">
                        <div class="field-control" :class="{'has-error': hasError(index, 'endDate')}">
                            <date-picker clear-button
                                         wrapper-class="date-picker-wrapper"
                                         :format="dateFormat"
                                         v-model="discount.endDate"
                                         name="endDate" />
                        </div>
                    </td>
                    <td class="actions">
                        <button @click="removeDiscount(index)" class="btn btn--red">
                            Verwijder
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

        <button @click="addDiscount" :disabled="saving" class="btn btn--secondary" :class="{disabled: saving}">
            Voeg nieuwe korting toe
        </button>

        <button @click="save" :disabled="saving" class="btn btn--orange" :class="{disabled: saving}">
            Opslaan
        </button>
    </div>
</template>

<script>
    import moment from 'moment/moment';
    import DatePicker from 'vuejs-datepicker';

    export default {
        name: 'ProductPricesDiscounts',
        components: {
            DatePicker,
        },

        data() {
            return {
                errors: {},
                discounts: [],
                saving: false,
            };
        },

        created() {
            axios.get(`/products/${this.$route.params.id}/discounts`)
                 .then(response => {
                     this.discounts = response.data.data;
                 });
        },

        methods: {
            save() {
                this.errors = {};
                this.saving = true;

                axios
                    .post(`/products/${this.$route.params.id}/discounts`, {
                        discounts: this.discounts.map(discount => {
                            discount.startDate = moment(discount.startDate).format('YYYY-MM-DD');
                            discount.endDate = discount.endDate ? moment(discount.endDate).format('YYYY-MM-DD') : null;

                            return discount;
                        }),
                    })
                    .then(response => {
                        this.discounts = response.data.data;

                        this.$flashMessage('Succesvol opgeslagen', 3500, 'succes');
                    })
                    .catch(error => {
                        this.errors = error.response.data.errors;

                        const errors = Object.entries(this.errors).flatMap(([field, errors]) => {
                            return errors.filter(e => e != null);
                        });

                        this.$flashMessage(errors.join('<br>'), 3500, 'error');
                    })
                    .finally(() => {
                        this.saving = false;
                    });
            },

            hasError(index, field) {
                return this.errors['discounts.' + index + '.' + field] != null && this.errors['discounts.' + index + '.' + field].length > 0;
            },

            dateFormat(date) {
                return moment(date).format('DD-MM-YYYY');
            },

            addDiscount() {
                this.discounts.push({
                    name: '',
                    discountPercentage: 0,
                    startDate: moment().toDate(),
                    endDate: null,
                });
            },

            removeDiscount(index) {
                this.discounts.splice(index, 1);
            },
        },
    };
</script>

<style scoped lang="scss">
    .content {
        display        : flex;
        flex-direction : column;
        gap            : 16px;

        .table {
            .field {
                padding : 8px;
            }

            .actions {
                width : 1%;
            }
        }

        .btn {
            width : fit-content;
        }

        .has-error {
            border-color : #DC3545;
        }

        ::v-deep {
            .date-picker-wrapper {
                & > div:first-child {
                    display        : flex;
                    flex-direction : row;
                    align-items    : center;
                    padding-right  : 12px;
                }
            }

            .vdp-datepicker {
                input {
                    height : 64px;
                }
            }
        }
    }
</style>
